import Day from './Day';
const Forecast = ({ forecastData, userLat, userLon }) => {
    if (!forecastData) {
        return <></>;
    }

    const data = forecastData;
    const timezone = data.timezone_offset;
    const days = data.daily;

    return (
        <>
            <section className='forecast'>
                <Day forecastData={days[1]} modTimezone={timezone} />
                <Day forecastData={days[2]} modTimezone={timezone} />
                <Day forecastData={days[3]} modTimezone={timezone} />
                <Day forecastData={days[4]} modTimezone={timezone} />
                <Day forecastData={days[5]} modTimezone={timezone} />
                <Day forecastData={days[6]} modTimezone={timezone} />
                <Day forecastData={days[7]} modTimezone={timezone} />
            </section>
            <h1 className='user-coords'>
                {userLat !== 0 && `Twoje współrzędne: `}
                {userLat !== 0 && (
                    <span>
                        {userLat.toFixed(4)}, {userLon.toFixed(4)}
                    </span>
                )}
            </h1>
        </>
    );
};

export default Forecast;

/*

                {lat !== 0 &&
                    'Twoje współrzędne: ' +
                    (
                        <span>
                            {lat.toFixed(4)} {lon.toFixed(4)}
                        </span>
                    )}

*/
